import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import ModalHeader from './ModalHeader';

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 600,
  bgcolor: 'background.paper',
  borderRadius: '5px',
  boxShadow: 24,
  p: 1,
};

interface Props {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  bookingLink: string;
  phoneNumber: string;
  firstName: string;
}

export default function OnboardedModal({
  open,
  setOpen,
  bookingLink,
  phoneNumber,
  firstName,
}: Props) {
  const handleClose = () => setOpen(false);

  const title = `Invite sent to ${firstName}!`;

  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description">
        <Box sx={style}>
          <ModalHeader name={title} handleClose={handleClose} />
          <Box
            style={{
              padding: '20px 10px',
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
            }}>
            <Typography variant="body1">
              {firstName} will receive an email with the following steps to
              finish creating their account:
            </Typography>

            <div className="step-section">
              <Typography variant="h3">
                1. Download the Porter Mobile App
              </Typography>
              <Typography variant="body2">
                Search &quot;Porter Business&quot; in the apple or android app
                store and download the Porter app. They can log in using the
                phone number you provided: {phoneNumber}
              </Typography>
            </div>
            <div className="step-section">
              <Typography variant="h3">
                2. Add Booking Link to Instagram
              </Typography>
              <Typography variant="body2">
                {firstName}&apos;s unique booking link is {bookingLink}. They
                can add this link to their instagram bio so clients can request
                appointments with them.
              </Typography>
            </div>
            <div className="step-section">
              <Typography variant="h3">3. Update Working Hours</Typography>
              <Typography variant="body2">
                {firstName} will need to update their weekly working hours in
                the Porter Mobile app. Navigate to Profile &gt; Availability
                &gt; Weekly Hours to update the hours they&apos;re in the
                studio.
              </Typography>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
